import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from 'vue-i18n-composable'
import { ref, computed, onBeforeUnmount } from 'vue'
import LfHeaderTitleComponent from '@/components/HeaderTitle/LfHeaderTitleComponent.vue'
import LfLabelButtonComponent from '@/components/forms/buttons/label/LfLabelButtonComponent.vue'
import SearchAdvanceIAComponent from '@/modules/documentSearcher/components/SearchAdvanceIA/SearchAdvanceIAComponent.vue'
import { LabelButtonVariant } from '@/components/forms/buttons/types/ButtonTypes'
import { useSearchIAStore } from '@/modules/documentSearcher/stores/useSearchIAStore'
import { TrackerEvents, trackEvent } from '@/plugins/tracker'

// TRANSLATIONS

export default /*#__PURE__*/_defineComponent({
  __name: 'SearchIAView',
  setup(__props) {

const { t } = useI18n()

const TEXT = {
  title: t('views.search_ia.title') as string,
  newQuery: t('action_buttons.new_query') as string,
  betaTooltip: 'BETA'
}

const ICON = {
  add: require('@/assets/images/svg/icon-add-circle.svg'),
  beta: require('@/assets/images/svg/icon-beta.svg')
}

// STORE
const searchIAStore = useSearchIAStore()

// REFS
const componentKey = ref(0)

// COMPUTED
const queryDone = computed(() => searchIAStore.queryDone)

// METHODS
const onNewQueryClick = () => {
  trackEvent(TrackerEvents.AI_SEARCH_NEW, { search_id: searchIAStore.search_id })
  resetState()
}

const resetState = () => {
  searchIAStore.resetSearchIAResponse()
  searchIAStore.cancelSearchIA()
  searchIAStore.resetSearchId()
  componentKey.value += 1
}

// LIFECYCLE
onBeforeUnmount(() => {
  resetState()
})

return { __sfc: true,t, TEXT, ICON, searchIAStore, componentKey, queryDone, onNewQueryClick, resetState, LfHeaderTitleComponent, LfLabelButtonComponent, SearchAdvanceIAComponent, LabelButtonVariant }
}

})